$(document).ready(function () {

    var $window = $(window);
    var windowWidth = $window.width();
    var featureLen = $("#packages .features > div").length;
    var str = $('.inventory-btn a').text();

    // Add has-sub-nav class to increse padding top
    $('.ahm-wrapper').addClass('has-sub-nav');

    //ADA fixes
    $("hr").attr('aria-hidden', 'true');
    $('.model-details h2').first().replaceWith(function () {
        return '<h1 class="hl-3">' + $(this).html() + '</h1>';
    });
    //end of ADA fixes

    // If the user scrolls down, hide sticky nav on mobile. Otherwise, show sticky nav on scroll up.
    if (windowWidth < 768) {
        $('html').on('DOMMouseScroll mousewheel', function (e) {
            if (e.originalEvent.detail > 0 || e.originalEvent.wheelDelta < 0) {
                //scroll down
                $(".acpv-header").addClass("hideme");
                $(".details-year-selector-wrapper").css("top", "0");
            } else {
                //scroll up
                $(".acpv-header").removeClass("hideme");
                $(".details-year-selector-wrapper").css("top", "60px");
            }
        });

        // change button size of TSX Wagon only
        if (str.toLowerCase().indexOf("wagon") >= 0) {
            $('.inventory-btn').css('width', '130px');
            $('.vehicle-badge img').css('width', '90%');
        }
        // Mobile - resize background image appropriately based on features count
        packagesHeight()

    } else {
        $('.inventory-btn').css('width', 'auto');
    }

    function packagesHeight() {
        // Mobile - resize background image appropriately based on features count
        if (featureLen == 4) {
            $('.model-details #packages').css('height', '320px');
        } else if (featureLen == 5 || featureLen == 6) {
            $('.model-details #packages').css('height', '420px');
        } else if (featureLen == 7) {
            $('.model-details #packages').css('height', '550px');
        } else if (featureLen == 8) {
            $('.model-details #packages').css('height', '610px');
        } else {
            $('.model-details #packages').css('height', '305px');
        }
    }

    $(window).on('resize', function () {
        var winWidth = $(window).width();

        if (winWidth < 768) {
            // Mobile - resize background image appropriately based on features count
            packagesHeight()
        }
    });

    // Tablet / Desktop - resize badge image for TSX wagon only
    if (windowWidth > 767) {
        if (str.toLowerCase().indexOf("wagon") >= 0) {
            $('.vehicle-badge img').css('width', '90%');
        }
    }

    // Tablet - resize background image appropriately based on features count
    if (windowWidth > 767 && windowWidth < 992 && featureLen > 6) {
        $('.model-details #packages').css('height', '400px');
    }

    // Add button text via js on download button
    $("#download-button a").html("DOWNLOAD BROCHURE");

    // Check if mobile device then open download brochure on a new tab
    var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
    if (isTouch) {
        $("#download-button a").attr('target', '_blank');
    }

    // If there is only 1 model year, hide dropdown (RL model)
    var yearLen = $('.year-dropdown li').length;
    if (yearLen < 2) {
        $('.wrapper-dropdown').css('visibility', 'hidden');
    }

    // const VIDEO_SOURCE = 'https://www.youtube.com/embed/twfVf_bJjO4';
    const YouTubeState = {
        NOT_LOADED: 0,
        LOADING: 1,
        LOADED: 2
    };

    // keep a record of which videos have been played using the video
    // url as the key
    const videoHasStarted = {};
    let videoUrl;
    let videoComponent;
    let youTubeState = YouTubeState.NOT_LOADED;

    // YouTube's iframe api will call this method
    window.onYouTubeIframeAPIReady = function () {
        videoComponent = createVideoComponent();
    };

    $(".watch-button .btn-video").click(showVideo);

    $(".overlay-close-button").click(close);

    function createVideoComponent() {
        const template = `
          <iframe
            frameborder="0"
            id="model-detail-video"
            src="${videoUrl}?enablejsapi=1&modestbranding=1&rel=0&showinfo=0">
          </iframe>
        `;

        const videoComponent = new Lightbox(template);

        videoComponent.player = new YT.Player('model-detail-video', {
            events: {
                onStateChange: (event) => {
                    if (event.data === YT.PlayerState.PLAYING) {
                        if (!videoHasStarted[videoUrl]) {
                            _satellite.track('modeldetail_video_start');
                        }

                        videoHasStarted[videoUrl] = true;
                    } else if (event.data === YT.PlayerState.ENDED) {
                        _satellite.track('modeldetail_video_complete');
                    }
                },
                onReady: () => {
                    youTubeState = YouTubeState.LOADED;
                    showVideo();
                }
            }
        });

        videoComponent.onClose = function () {
            this.player.pauseVideo();
        };

        videoComponent.onOpen = function () {
            this.player.playVideo();
        };

        return videoComponent;
    }

    function loadYouTubeApi() {
        const script = document.createElement('script');

        script.src = 'https://www.youtube.com/iframe_api';
        script.type = 'text/javascript';

        document.head.appendChild(script);

        youTubeState = YouTubeState.LOADING;
    }

    function showVideo(event) {

        const videoId = $(".btn-video").attr("data-videoid");

        videoUrl = `https://www.youtube.com/embed/${videoId}`;

        if (youTubeState === YouTubeState.NOT_LOADED) {
            return loadYouTubeApi();
        }

        if (youTubeState === YouTubeState.LOADING) {
            return;
        }

        videoComponent.open();
    }

    // Year drop down Start
    function DropDown(el) {
        this.dd = el;
        this.placeholder = this.dd.children('span');
        this.opts = this.dd.find('li[role="menuitem"] a');
        // this.url = this.dd.find('ul.year-dropdown > li a').attr('href');
        this.val = '';
        this.index = -1;
        this.initEvents();
    }
    DropDown.prototype = {
        initEvents: function () {
            var obj = this;

            obj.dd.on('click', function (event) {
                resetMenu(obj.opts);
                $(this).toggleClass('active');
                $(this).find('span').attr('aria-expanded','true');
                obj.opts.eq(0).attr('tabindex', 0);
                obj.opts.eq(0).focus();
                return false;
            });
            obj.dd.on('keydown', function (event) {
                if (event.key === 'Enter') {
                    $(this).trigger('click');
                }
            });


            obj.opts.on('click', function () {
                // Tracking
                // _satellite.track("modeldetail_toggle_year");

                var opt = $(this);
                var url = $(this).attr('href');
                var pathname = window.location.pathname;
                if (url.toLowerCase() !== pathname.toLowerCase()) {
                    obj.val = opt.text();
                    obj.index = opt.index();
                    obj.placeholder.text(obj.val);
                    //redirect to new model year page

                    window.location.href = url;
                }
            });

            obj.opts.on('keydown', function (event) {
                event.preventDefault();
                if (event.key === 'Enter') {
                    $(this).trigger('click');
                }
            });

            obj.opts.each(function(index) {
                $(this).on('keydown', function(event) {
                  if (event.key === 'Escape') {
                    event.preventDefault();
                    obj.dd.trigger('click');
                    $('.dropdown-toggle').focus().attr('aria-expanded','false');
                    resetMenu(obj.opts)
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    resetMenu(obj.opts)
                    if (index === 0) {
                        obj.opts.eq(obj.opts.length - 1).attr('tabindex', 0);
                        obj.opts.eq(obj.opts.length - 1).focus();
                    } else {
                        obj.opts.eq(index - 1).attr('tabindex', 0);
                        obj.opts.eq(index - 1).focus();
                    }
                    } else if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    resetMenu(obj.opts)
                    if (index === obj.opts.length - 1) {
                        obj.opts.eq(0).attr('tabindex', 0);
                        obj.opts.eq(0).focus();
                    } else {
                        obj.opts.eq(index + 1).attr('tabindex', 0);
                        obj.opts.eq(index + 1).focus();
                    }
                  }
                });
              });
        },
        getValue: function () {
            return this.val;
        },
        getIndex: function () {
            return this.index;
        }
    }

    let resetMenu = function (options) {
        options.each(function () { $(this).attr('tabindex', -1); });
    }

    $(function () {
        var dd = new DropDown($('#year-dd'));

        $(document).click(function () {
            // all dropdowns
            if ($('.wrapper-dropdown').hasClass('active')) {
                $('.wrapper-dropdown').removeClass('active');
                $('.dropdown-toggle').focus().attr('aria-expanded','false');
                $('.year-dropdown').find('li[role="menuitem"] a').eq(0).attr('tabindex', -1);
            }
        });
    });
});